import { Injectable } from '@angular/core';
import constantURL from 'src/app/shared/constantURL';
import { BillerBaseLoggedInPostService } from 'src/app/shared/services/biller-base-logged-in-post.service';
@Injectable({
    providedIn: 'root'
  })
  export class prepareNonInquireTransaction extends BillerBaseLoggedInPostService {
    _path = constantURL.BillPayments.Transaction.nonInquire
    public totalAmount : number
    public nonInqtrxResponse:InonInqtrxResponse
    public setResponse(data:any){
        this.nonInqtrxResponse = data
    }
    public setTotalAmount(n:number){
      this.totalAmount = n
    }
  }

export interface InonInqtrxResponse{
    ID: number,
    billerService:number,
    status: string,
    RefNum: string,
    amount: string,
    UserId: number,
    input_param_key: string,
    input_param_value: string,
    updatedAt: string,
    createdAt: string
}